/* =======================================
    ELTAMD-18: Password validation
========================================== */
$( document ).ready(function() {
  var passwordInput = $('input.password-custom-validation');

  $(passwordInput).keyup(function() {
    var number = /([0-9])/;
    var upperCase= new RegExp('[A-Z]');
    var lowerCase= new RegExp('[a-z]');
    var special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
    var submitBtn = $('.password-custom-validation--submit');

    if ($(this).val().length < 6) {
        $(submitBtn).prop('disabled', true);
        $('#password-strength-status').removeClass();
        $('#password-strength-status').addClass('weak-password');
        $('#password-strength-status').html("Weak (Password should be at least 6 characters.)");
    } else {
        if ($(this).val().match(number) && $(this).val().match(upperCase) && $(this).val().match(lowerCase) && $(this).val().match(special_characters)) {
          $(submitBtn).prop('disabled', false);
          $('#password-strength-status').removeClass();
          $('#password-strength-status').addClass('strong-password');
          $('#password-strength-status').html("Strong password");

        } else {
          $(submitBtn).prop('disabled', true);
          $('#password-strength-status').removeClass();
          $('#password-strength-status').addClass('medium-password');
          $('#password-strength-status').html("Medium (Password should include uppercase & lower case letters, numbers and special characters.)");
        }
    }
  });
});

/* =======================================
  ELTAMD-83: Physician Locator
========================================== */
$( document ).ready(function() {
// Open/close
$(document).on('click', '.dropdown-select', function (event) {
  if($(event.target).hasClass('dd-searchbox')){
      return;
  }
  $('.dropdown-select').not($(this)).removeClass('open');
  $(this).toggleClass('open');
});

// Close when clicking outside
$(document).on('click', function (event) {
  if ($(event.target).closest('.dropdown-select').length === 0) {
      $('.dropdown-select').removeClass('open');
  }
  event.stopPropagation();
});

// Option click
$(document).on('click', '.dropdown-select li', function () {
  $(this).closest('.list').find('.selected').removeClass('selected');
  $(this).addClass('selected');
  var text = $(this).data('display-text') || $(this).text();
  var check = $(this).find("input:checked").length > 0;
  if (check) {
    $(this).closest('.dropdown-select').find('.current').text(text);
  } else {
    $(this).closest('.dropdown-select').find('.current').text("Select a Physician");
  }
});

// Enroll Button Logic
$(document).on('click', '.list-details .scasl-list-content__column .enrollBtnJS', function (event) {
  event.preventDefault();
  var physicianName = $(this).parents('.scasl-list-content__column').find('#scasl-title').text();
  var accountID = $(this).parents('.scasl-list-content__column').find('#scasl-title').attr("data-account-id");
  var Zipcode = $(this).parents('.scasl-list-content__column').find('#scasl-title').attr("data-zipcode");

  $('.enroll-step-1').hide();
  $('.enroll-step-2').show();
  $('.enroll-to-buy-steps .enroll-to-buy-steps__item:nth-child(1)').removeClass('enroll-to-buy-steps__item--active');
  $('.enroll-to-buy-steps .enroll-to-buy-steps__item:nth-child(2)').addClass('enroll-to-buy-steps__item--active');

  $('.enroll-step-2 .currentPhysicianJS').text(physicianName);
  $('#create_customer').find('#CustomerFormPhysician').val(physicianName);
  $('#create_customer').find('#CustomerFormAccountID').val(accountID);
  $('#create_customer').find('#CustomerFormZipcode').val(Zipcode);
  var cartCount = $('#CartCount').text();
  var cartCountFormated = parseInt(cartCount);
  var redirectInput = $('input[name="redirect_url"]');

  if (cartCountFormated > 0) {
    $(redirectInput).val('/checkout');
  } else {
    $(redirectInput).val('/');
  }
});

$(document).on('click', '.enroll-step-2 .current-physician-selection .backToStep1JS', function (event) {
  event.preventDefault();
  $('.enroll-step-1').show();
  $('.enroll-step-2').hide();
  $('.enroll-to-buy-steps .enroll-to-buy-steps__item:nth-child(1)').addClass('enroll-to-buy-steps__item--active');
  $('.enroll-to-buy-steps .enroll-to-buy-steps__item:nth-child(2)').removeClass('enroll-to-buy-steps__item--active');
});
});

function filter(){
var valThis = $('#txtSearchValue').val();
$('.dropdown-select ul > li').each(function(){
 var text = $(this).text();
    (text.toLowerCase().indexOf(valThis.toLowerCase()) > -1) ? $(this).show() : $(this).hide();
});
};
// Search
$(document).ready(function() {
$(document).on('click', '.modalDesktopBtnJS', function (event) {
  var productURL = $(this).data( "product-url" );
  localStorage.setItem("product-url", productURL);

  if ($(window).width() > 767) {
    var quickViewComponent = $(this).parents('.quick-view-popup').length;

    if (quickViewComponent === 0) {
      event.preventDefault();

      var modalDesktop = $('.modal-desktop');
      modalDesktop.fadeIn();
    }
  }
});

$(document).on('click', '.modalDesktopCloseBtnJS', function (event) {
    event.preventDefault();

    var modalDesktop = $('.modal-desktop');
    modalDesktop.fadeOut();
});

$(document).on('click', '.modal-desktop__overlay', function (event) {
  event.preventDefault();

  var modalDesktop = $(this).parents('.modal-desktop');
  modalDesktop.fadeOut();
});

$(document).on('click', '.scasl-list-content__accordion', function () {
  var accordionContent = $(this).parents('.scasl-list-content__column').find('.scasl-list-content__column--icon');

  $(this).toggleClass('accordion--active');
  $(accordionContent).slideToggle(350);
});

// $(document).on('click', '.enroll-to-buy-enrolled-link', function (event) {
//   event.preventDefault();

//   var productURL = $(this).data( "product-url" );
//   localStorage.setItem("product-url", productURL);
//   window.location.href = "/account/login";
// });
});

// Clear cart on customer logout
$(document).ready(function() {
$(document).on('click', '.customer-links .logout-link a', function (event) {
  event.preventDefault();

  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    success: function(){
      window.location.href = "/account/logout";
    },
    dataType: 'json'
  });
});
});

$( document ).ready(function() {
setTimeout(function(){
  if ($('.bh-sl-map.scasl-map > div').length > 0) {
    $('.spinner').hide();
    $('input#bh-sl-address').change();
  }
}, 10000);
});

/* =======================================
  ELTAMD-88: Virtual Bundle Product Work
========================================== */
$(window).bind("load", function() {

setTimeout(function () {

 if($(".mw-gp-container").length){
  $("#ProductPrice-product-template").html($(".mw-gp__subtotal__amount").html());
  $("#ComparePrice-product-template").html($(".mw-gp__subtotal__compare").html());
  $("#SaveAmount-product-template").html($(".mw-gp__enhanced__font__dark").html());
  $(".discount-badge .off").hide();
  }
}, 1500);

});

$( document ).ready(function() {
var ascending = true;
var myFuncCalls = 0;

var doSort = function ( ascending ) {
  myFuncCalls++;

  var $storeList = $('#bh-sl-map-container ul.list');
  var $stores = $storeList.children('li');
  var sortList = Array.prototype.sort.bind($stores);

  if (myFuncCalls%2 == 0) {
    sortList(function ( a, b ) {

      var aClass = a.className;
      var bClass = b.className;

      if ( aClass < bClass ) {
        return ascending ? -1 : 1;
      }

      if ( aClass > bClass ) {
        return ascending ? 1 : -1;
    }

      return 0;
  });
  } else {
    sortList(function ( a, b ) {

      var aClass = a.className;
      var bClass = b.className;

      if ( aClass > bClass ) {
        return ascending ? -1 : 1;
      }

      if ( aClass < bClass ) {
        return ascending ? 1 : -1;
    }

      return 0;
  });
  }

  $storeList.append($stores);

};

function shuffle(elems) {

allElems = (function(){
var ret = [], l = elems.length;
while (l--) { ret[ret.length] = elems[l]; }
return ret;
  })();

  var shuffled = (function(){
      var l = allElems.length, ret = [];
      while (l--) {
          var random = Math.floor(Math.random() * allElems.length),
              randEl = allElems[random].cloneNode(true);
          allElems.splice(random, 1);
          ret[ret.length] = randEl;
      }
      return ret;
  })(), l = elems.length;

  while (l--) {
      elems[l].parentNode.insertBefore(shuffled[l], elems[l].nextSibling);
      elems[l].parentNode.removeChild(elems[l]);
  }

}

$("#bh-sl-user-location").submit(function() {
  setTimeout(function(){
    if ($('#bh-sl-user-location').hasClass('bh-sl-user-location--enroll-to-buy')) {
      shuffle($('#bh-sl-map-container ul.list > li'));
    }

    doSort(ascending);
    ascending = !ascending;
   }, 1500);
});

$('input#bh-sl-address').on("change paste", function() {
  setTimeout(function(){
    if ($('#bh-sl-user-location').hasClass('bh-sl-user-location--enroll-to-buy')) {
      shuffle($('#bh-sl-map-container ul.list > li'));
    }
    doSort(ascending);
    ascending = !ascending;
   }, 1500);
});
});

$( document ).ready(function() {
$(document).on('focus', '.scasl-address-wrap #bh-sl-address', function () {
  $('.clear-input').css("opacity", "1");
});

$(document).on('focusout', '.scasl-address-wrap #bh-sl-address', function () {
  $('.clear-input').css("opacity", "0");
});

$(document).on('click', '.scasl-address-wrap .clear-input', function (event) {
  event.preventDefault();

  var addressInput = $(this).parents('.scasl-address-wrap').find('#bh-sl-address');
  $(addressInput).val("");
  $(addressInput).focus();
});
});

$( document ).ready(function() {
$(document).on('click', '.enroll-icon-mobile', function (event) {
  event.preventDefault();
  $(".enroll-to-buy-tooltip").toggleClass("active");
});
});

// ELTAMD-237: Redirect user to PDP After Login
$( document ).ready(function() {
var form = document.querySelectorAll('[action="/account/login"]');
for (var i = 0; i < form.length; i++) {
  var cartCount = $('#CartCount').text();
  var cartCountFormated = parseInt(cartCount);
  // if cart has a subscription item route back to page in case logged in user does not have a selected store.
  if (cartCountFormated > 0 && !window.asp.hasSubscription && window.location.pathname === '/cart') {
    form[i].innerHTML += '<input type="hidden" name="return_to" value="/checkout">';
  } else {
    var hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'return_to';
    if(window.location.pathname === '/cart'){
      hiddenInput.value = '/cart';
    } else {
      hiddenInput.value = '/account';
    }
    form[i].appendChild(hiddenInput);
  }
}
});





// ELTAMD-239: Redirect user to PDP After Registration
$( document ).ready(function() {
var form = document.querySelectorAll('[action="/account"]');
var button = $(form).find('button.btn');

$(button).click(function() {
  var interval = setInterval(redirectUser, 300);
  function redirectUser() {
    var spanText = $(button).find('span').text();
    var formAccount = $(button).parents('form');
    var errors = formAccount.find('.errors__green');

    if (errors.length) {
      clearInterval(interval);
      $(errors).parents('.errors').addClass('errors--green');
      $(formAccount).addClass('create_customer--blocked');
    }

    if(spanText === 'Redirecting...') {
      clearInterval(interval);
      var cartCount = $('#CartCount').text();
      var cartCountFormated = parseInt(cartCount);
      if (cartCountFormated > 0) {
        window.location.href = "/checkout";
      } else {
        window.location.href = "/";
      }
    }
  };
});
});

$( document ).ready(function() {
$(document).on('click', '#RecoverPassword', function () {
  $('#RecoverPasswordForm').toggleClass('hide');
  $('#CustomerLoginForm').toggleClass('hide');
});
});

$( document ).ready(function() {
var interval = setInterval(setSlickWrapperTitle, 300);
  function setSlickWrapperTitle() {
    if ( $('.slick-track').length ) {
      $('.slick-track').attr('aria-label', 'Homepage Carousel');
      clearInterval(interval);
    }
  }
});

// Redirect custom to my account page after change physician
$(document).ready(function() {
$(document).on('click', '.jsUpdateAccountBtn', function () {
  localStorage.setItem('product-url', '/account');
});
});


/**
 * OrderGroove widget - show price and subscription price exclusively
 * Displays subscription prices with a 10% discount from the original price
 * OG only shows prices on the widget when OG promotions are active
 * @author: @junaidkbr
 */
class OrderGrooveWidget {
  constructor(options = {}) {
    this.MAX_RETRIES = options.maxRetries || 20;
    this.RETRY_DELAY = options.retryDelay || 1000; // 1 second delay between retries
    this.SELECTOR = options.selector || 'og-offer';
    this.widgets = [];

    // Constants for class names and styles
    this.CLASSES = {
      REGULAR_PRICE: 'og-regular-price italic line-through',
      SUBSCRIPTION_PRICE: 'og-subscription-price'
    };

    this.STYLES = {
      SUBSCRIPTION_PRICE: {
        fontWeight: '700',
        color: 'var(--og-global-color, #090909)',
        marginLeft: '5px'
      }
    };
  }

  /**
   * Creates a price element with the specified class and text content
   * @param {string} className - The class name for the element
   * @param {string} textContent - The text content for the element
   * @param {Object} styles - Optional styles to apply
   * @returns {HTMLElement} The created element
   */
  createPriceElement(className, textContent, styles = {}) {
    const element = document.createElement('span');
    element.className = className;
    element.textContent = textContent;
    Object.assign(element.style, styles);
    return element;
  }

  /**
   * Checks if OrderGroove element is rendered with frequency attribute
   * @param {Element} element - The OG offer element to check
   * @returns {Promise<{isRendered: boolean, element: Element|null}>}
   */
  isOGRendered(element) {
    return new Promise((resolve) => {
      let retryCount = 0;
      let debounceTimer;

      const check = () => {
        clearTimeout(debounceTimer);

        if (element) {
          const frequency = element.getAttribute("frequency");

          if (frequency) {
            resolve({ isRendered: true, element });
            return;
          }
        }

        if (retryCount < this.MAX_RETRIES) {
          retryCount++;
          debounceTimer = setTimeout(check, this.RETRY_DELAY);
        } else {
          resolve({ isRendered: false, element: null });
        }
      };

      check();
    });
  }

  /**
   * Process a single OrderGroove offer element
   * @param {Element} element - The OG offer element to process
   */
  processOGElement(element) {
    this.isOGRendered(element).then(({ isRendered, element }) => {
      if (!isRendered || this.widgets.includes(element)) return;

      this.widgets.push(element);

      const priceCents = element.getAttribute("price");
      const ogSubscriptionOption = element.querySelector('og-when > div:nth-child(2)');

      if (!ogSubscriptionOption || !priceCents) {
        return;
      }

      const regularPrice = Shopify.money_format.replace('{{amount}}', (priceCents / 100).toFixed(2));
      const subscriptionPrice = Shopify.money_format.replace('{{amount}}', (priceCents * 0.9 / 100).toFixed(2));

      // Replace regular price
      const ogRegularPriceElement = ogSubscriptionOption.querySelector('og-price[regular]');
      if (ogRegularPriceElement && regularPrice) {
        const newRegularPriceElement = this.createPriceElement(
          this.CLASSES.REGULAR_PRICE,
          regularPrice
        );
        ogRegularPriceElement.parentNode.appendChild(newRegularPriceElement);
      }

      // Replace subscription price
      const ogSubscriptionPriceElement = ogSubscriptionOption.querySelector('og-price[subscription]');
      if (ogSubscriptionPriceElement && subscriptionPrice) {
        const newSubscriptionPriceElement = this.createPriceElement(
          this.CLASSES.SUBSCRIPTION_PRICE,
          subscriptionPrice,
          this.STYLES.SUBSCRIPTION_PRICE
        );
        ogSubscriptionPriceElement.parentNode.appendChild(newSubscriptionPriceElement);
      }
    });
  }

  /**
   * Initialize the OrderGroove widget functionality
   */
  init() {
    const ogOfferElements = document.querySelectorAll(this.SELECTOR);

    if (!ogOfferElements.length) {
      return;
    }

    // Process each OrderGroove offer element
    ogOfferElements.forEach(element => this.processOGElement(element));
  }
}

// Initialize the OrderGroove widget on DOM content loaded with an anonymous function
document.addEventListener("DOMContentLoaded", () => {
  window.ogWidget = new OrderGrooveWidget();
  window.ogWidget.init();
});
